import React, { useState } from 'react';

export default function Result({ data = {} }) {
  const [copied, setCopied] = useState(false);

  const replyProbability = data.reply_probability || 75;
  const psychologicalFlaw = data.psychological_flaw || 'No flaw detected';
  const instantFix = data.instant_fix || 'No fix provided';
  const subjectLine = data.subject_line || 'Subject line';
  const emailBody = data.email_body || 'Email content';

  const handleCopy = async () => {
    const emailContent = `Subject: ${subjectLine}\n\n${emailBody}`;

    try {
      await navigator.clipboard.writeText(emailContent);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (error) {
      console.error('Clipboard error:', error);
    }
  };

  return (
    <div className="mt-8 rounded-[28px] border border-gray-200/60 bg-white p-5 sm:p-6">
      <div className="grid gap-5 lg:grid-cols-[1.1fr_0.9fr]">
        <div className="space-y-4">
          <div className="rounded-[20px] border border-gray-200 bg-[#fffdfa] p-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gray-700">Subject Line</p>
            <p className="mt-3 text-lg font-bold text-gray-950">{subjectLine}</p>
          </div>

          <div className="rounded-[20px] border border-gray-200 bg-[#fffdfa] p-4">
            <div className="flex items-center justify-between gap-3">
              <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gray-700">Email Body</p>
              <button
                type="button"
                onClick={handleCopy}
                className="rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-900"
              >
                {copied ? '✓ Copied' : 'Copy'}
              </button>
            </div>
            <pre className="mt-4 whitespace-pre-wrap text-sm leading-7 text-gray-800">{emailBody}</pre>
          </div>
        </div>

        <div className="space-y-4">
          <div className="rounded-[20px] border border-gray-200 bg-[#fffdfa] p-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gray-700">Reply Probability</p>
            <div className="mt-4 flex justify-center">
              <div
                className="relative flex h-40 w-40 items-center justify-center rounded-full"
                style={{
                  background: `conic-gradient(from 0deg, #111827 0%, #111827 ${replyProbability}%, #f1e6d0 ${replyProbability}%, #f1e6d0 100%)`
                }}
              >
                <div className="flex h-32 w-32 flex-col items-center justify-center rounded-full bg-white">
                  <span className="text-3xl font-black text-gray-950">{replyProbability}%</span>
                  <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-gray-700">Score</span>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-[20px] border border-gray-200 bg-[#fffdfa] p-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gray-700">Psychological Flaw</p>
            <p className="mt-3 text-sm leading-7 text-gray-800">{psychologicalFlaw}</p>
          </div>

          <div className="rounded-[20px] border border-gray-200 bg-[#fffdfa] p-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gray-700">Instant Fix</p>
            <p className="mt-3 text-sm leading-7 text-gray-800">{instantFix}</p>
          </div>
        </div>
      </div>
    </div>
  );
}